<ng-select (change)="changeABTest($event)" [placeholder]="'Apply Variation'" [searchable]="false" [clearable]="false">
  <ng-option *ngFor="let item of abTests$ | async" [value]="item.code" [class]="'select-option-item'">{{item.code}} ({{item.value}})</ng-option>
</ng-select>
